export default __webpack_public_path__ + "c479f3434837f014ca86ee3ce7fc46a3.svg";